<template>
  <svg width="166" height="33" viewBox="0 0 166 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1948_22481)">
      <path
        d="M59.0903 23.4935L52.2758 14.0313V23.4935H49.2344V8.98453H52.365L58.9863 18.0977V8.98453H62.0277V23.4935H59.0903Z"
        fill="#25374C"
      />
      <path
        d="M67.1712 16.2484C67.1712 11.8775 70.3204 8.74319 74.6281 8.74319C78.9359 8.74319 82.1073 11.8775 82.1073 16.2484C82.1073 20.6193 78.9582 23.7535 74.6281 23.7535C70.2981 23.7535 67.1712 20.623 67.1712 16.2484ZM78.9804 16.2484C78.9804 13.53 77.2648 11.4838 74.6318 11.4838C71.9989 11.4838 70.3018 13.53 70.3018 16.2484C70.3018 18.9667 71.9952 21.0129 74.6318 21.0129C77.2685 21.0129 78.9804 18.9481 78.9804 16.2484Z"
        fill="#25374C"
      />
      <path
        d="M90.8265 23.4935L85.2969 8.98453H88.7691L92.7353 20.1439L96.6791 8.98453H100.151L94.644 23.4935H90.8302H90.8265Z"
        fill="#25374C"
      />
      <path
        d="M113.327 23.4935L112.447 21.0351H106.32L105.421 23.4935H101.949L107.478 8.98453H111.292L116.8 23.4935H113.327ZM109.383 12.0742L107.155 18.3168H111.612L109.383 12.0742Z"
        fill="#25374C"
      />
      <path
        d="M123.056 23.4935V11.7029H118.879V8.98453H130.279V11.7029H126.12V23.4935H123.056Z"
        fill="#25374C"
      />
      <path
        d="M134.027 16.2483C134.027 11.8774 137.176 8.74313 141.483 8.74313C145.791 8.74313 148.963 11.8774 148.963 16.2483C148.963 20.6192 145.814 23.7535 141.483 23.7535C137.153 23.7535 134.027 20.6229 134.027 16.2483ZM145.836 16.2483C145.836 13.53 144.12 11.4838 141.487 11.4838C138.854 11.4838 137.157 13.53 137.157 16.2483C137.157 18.9666 138.851 21.0128 141.487 21.0128C144.124 21.0128 145.836 18.9481 145.836 16.2483Z"
        fill="#25374C"
      />
      <path
        d="M162.187 23.4935L159.38 18.3391H157.152V23.4935H154.11V8.98453H160.795C163.773 8.98453 165.596 10.9639 165.596 13.6599C165.596 16.356 164.011 17.5963 162.47 17.9677L165.685 23.4935H162.191H162.187ZM162.488 13.6599C162.488 12.4419 161.567 11.7029 160.345 11.7029H157.152V15.617H160.345C161.567 15.617 162.488 14.878 162.488 13.6599Z"
        fill="#25374C"
      />
      <path
        d="M13.3172 17.3104L0.000274658 0.250122L13.3098 0.517501L13.3172 17.3104Z"
        fill="#089591"
      />
      <path d="M13.3208 28.967L5.55569 26.3006L13.3208 20.1064V28.967Z" fill="#25374C" />
      <path d="M14.3979 0.487579L33.0475 19.9356L14.409 29.1565L14.3979 0.487579Z" fill="#25374C" />
      <path d="M38.2534 5.45963L33.5371 18.8768L24.424 9.37746L38.2534 5.45963Z" fill="#25374C" />
      <path d="M42.6618 8.99561L38.2241 8.81365L39.3196 5.70166L42.6618 8.99561Z" fill="#25374C" />
      <path d="M12.8936 29.9696L3.61703 32.2498L4.91679 27.229L12.8936 29.9696Z" fill="#25374C" />
    </g>
    <defs>
      <clipPath id="clip0_1948_22481">
        <rect width="165.678" height="32" fill="white" transform="translate(0 0.25)" />
      </clipPath>
    </defs>
  </svg>
</template>
